import { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";

export const FirefoxWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if Firefox
    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
    
    // Check if warning was already dismissed
    const wasDismissed = localStorage.getItem("firefox_warning_dismissed");
    
    if (isFirefox && !wasDismissed) {
      setShowWarning(true);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    setShowWarning(false);
    localStorage.setItem("firefox_warning_dismissed", "true");
  };

  if (!showWarning || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-in slide-in-from-bottom-5 duration-300">
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          </div>
          <div className="flex-1">
            <h4 className="font-medium text-amber-800 text-sm">
              Avviso per utenti Firefox
            </h4>
            <p className="text-amber-700 text-xs mt-1">
              Se riscontri problemi con il login, ti consigliamo di usare Google Chrome o di disattivare la "Protezione antitracciamento avanzata" per questo sito.
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 text-amber-600 hover:text-amber-800 transition-colors"
            aria-label="Chiudi avviso"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
